const T = "6.4rem";
const o = "5.2rem";
const O = "4.0rem";
const I = "3.6rem";
const H = "3.2rem";
const L = "2.4rem";
const F = "3.6rem";
const A = "3.2rem";
const h = "2.8rem";
const l = "2.4rem";
const f = "2.0rem";
const N = "2.8rem";
const n = "2.4rem";
const e = "2.4rem";
const t = "2.0rem";
const E = "1.6rem";
const g = "1.6rem", S = "0.05rem", _ = {
  fontFeatureSettings: "'liga' off",
  fontStyle: "normal",
  textRendering: "optimizeLegibility"
}, c = (i) => ({
  fontFamily: ["Lato", "sans-serif"].join(","),
  fontSize: 16,
  fontWeightRegular: 400,
  fontWeightBold: 700,
  // all the built-in MUI variants (note that these override some of the base attributes above, so we need to
  // re-specify them instead of relying on inheritance)
  body1: {
    ..._,
    color: i.text.primary,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: t
  },
  body2: {
    ..._,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: E
  },
  button: {
    ..._,
    textTransform: "none",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: t
  },
  caption: {
    ..._,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: E
  },
  h1: {
    ..._,
    fontSize: 48,
    fontWeight: 400,
    lineHeight: T
  },
  h2: {
    ..._,
    fontSize: 40,
    fontWeight: 400,
    lineHeight: o
  },
  h3: {
    ..._,
    fontSize: 32,
    fontWeight: 400,
    lineHeight: O
  },
  h4: {
    ..._,
    fontSize: 28,
    fontWeight: 400,
    lineHeight: I
  },
  h5: {
    ..._,
    fontSize: 24,
    fontWeight: 400,
    lineHeight: H
  },
  h6: {
    ..._,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: L
  },
  overline: {
    ..._,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: e
  },
  subtitle1: {
    ..._,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: e
  },
  subtitle2: {
    ..._,
    color: i.text.disabled,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: t
  },
  // custom Life variants
  //#region Headline
  headlineXl: {
    ..._,
    fontSize: 48,
    lineHeight: T,
    fontWeight: 400
  },
  headlineL: {
    ..._,
    fontSize: 40,
    lineHeight: o,
    fontWeight: 400
  },
  headlineM: {
    ..._,
    fontSize: 32,
    lineHeight: O,
    fontWeight: 400
  },
  headlineS: {
    ..._,
    fontSize: 28,
    lineHeight: I,
    fontWeight: 400
  },
  headlineXs: {
    ..._,
    fontSize: 24,
    lineHeight: H,
    fontWeight: 400
  },
  headlineXxs: {
    ..._,
    fontSize: 20,
    lineHeight: L,
    fontWeight: 400
  },
  //#endregion Headline
  //#region Paragraph
  paragraphXl: {
    ..._,
    fontSize: 24,
    lineHeight: F
  },
  paragraphL: {
    ..._,
    fontSize: 20,
    lineHeight: A
  },
  paragraphM: {
    ..._,
    fontSize: 18,
    lineHeight: h
  },
  paragraphS: {
    ..._,
    fontSize: 16,
    lineHeight: l
  },
  paragraphXs: {
    ..._,
    fontSize: 14,
    lineHeight: f
  },
  //#endregion Paragraph
  //#region Component
  componentXl: {
    ..._,
    fontSize: 24,
    lineHeight: N
  },
  componentL: {
    ..._,
    fontSize: 20,
    lineHeight: n
  },
  componentM: {
    ..._,
    fontSize: 18,
    lineHeight: e
  },
  componentS: {
    ..._,
    fontSize: 16,
    lineHeight: t
  },
  componentXs: {
    ..._,
    fontSize: 14,
    lineHeight: E
  },
  componentXxs: {
    ..._,
    fontSize: 12,
    lineHeight: g
  },
  // Component Bold
  componentBoldXl: {
    ..._,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: N
  },
  componentBoldL: {
    ..._,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: n
  },
  componentBoldM: {
    ..._,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: e
  },
  componentBoldS: {
    ..._,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: t
  },
  componentBoldXs: {
    ..._,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: E
  },
  // Component Italic
  componentItalicXl: {
    ..._,
    fontSize: 24,
    fontStyle: "italic",
    lineHeight: N
  },
  componentItalicL: {
    ..._,
    fontSize: 20,
    fontStyle: "italic",
    lineHeight: n
  },
  componentItalicM: {
    ..._,
    fontSize: 18,
    fontStyle: "italic",
    lineHeight: e
  },
  componentItalicS: {
    ..._,
    fontSize: 16,
    fontStyle: "italic",
    lineHeight: t
  },
  componentItalicXs: {
    ..._,
    fontSize: 14,
    fontStyle: "italic",
    lineHeight: E
  },
  // Component Uppercase
  componentUppercaseM: {
    ..._,
    fontSize: 18,
    lineHeight: e,
    fontWeight: 700,
    letterSpacing: S,
    textTransform: "uppercase"
  },
  componentUppercaseS: {
    ..._,
    fontSize: 16,
    lineHeight: t,
    fontWeight: 700,
    letterSpacing: S,
    textTransform: "uppercase"
  },
  componentUppercaseXs: {
    ..._,
    fontSize: 14,
    lineHeight: E,
    fontWeight: 700,
    letterSpacing: S,
    textTransform: "uppercase"
  }
  //#endregion Component
});
export {
  c as default
};
//# sourceMappingURL=typography.js.map
